function householdWithChildrenSelect(e) {
    if ($(e).is(':checked')) {
        $(e).prop('checked', true);
        if ($(e).val() == "Y") {
            $('#ChildrenAgeFrom').removeAttr('disabled');
            $('#ChildrenAgeTo').removeAttr('disabled');
        } else {
            $('#ChildrenAgeFrom').attr('disabled', 'disabled');
            $('#ChildrenAgeTo').attr('disabled', 'disabled');
        }
    } else {
        $(e).prop('checked', false);
    }
    UpdateHouseholdWithChildrenSelection();
};

function UpdateHouseholdWithChildrenSelection() {
    var $childrenSelections = $('#formResidentsContainer input#SerializedHouseholdWithChildren:hidden');

    var childrenSelections = new Array();
    $('.ResidentsSelection input:radio:checked').each(function (i, o) {
        childrenSelections.push($(o).attr('id') + ':' + $(o).val());
    });
    $childrenSelections.val(childrenSelections.join('~'));    
};

$(function () {
    UpdateHouseholdWithChildrenSelection();   
});

